/// <reference path="../../../app.definition.ts" />

import angular from "angular";
export class AccountLimitAlertController {
  static $inject = ["$uibModalInstance", "title", "message", "$state", "plans"];

  constructor($uibModalInstance, title, message, $state, plans) {
    var accountLimitAlertVm: any = this;

    accountLimitAlertVm.title = title;
    accountLimitAlertVm.message = message
    accountLimitAlertVm.plans = plans;

    accountLimitAlertVm.close = () => {
      $uibModalInstance.dismiss();
    }

    accountLimitAlertVm.review = () => {
      $uibModalInstance.close(true);
      $state.go('parent-profile', { page: 'mySubscription' });
    }
  };
}


angular.module('eCareVault.common.popUp')
  .controller('AccountLimitAlertController', AccountLimitAlertController);
